<template>
	<pui-modal-dialog
		v-if="show"
		:cancelText="$t('form.cancel')"
		:okText="$t('form.save')"
		:disableOk="disableOk"
		:titleText="titleText"
		:messageText="messageText"
		dialogName="resetPasswordUser"
	>
		<template slot="message">
			<v-layout wrap>
				<v-flex xs12>
					<pui-text-field
						toplabel
						:label="$t('puiuserresetpassword.newpassword')"
						v-model="newPassword"
						type="password"
						required
						realtime
					></pui-text-field>
					<pui-text-field
						toplabel
						:label="$t('puiuserresetpassword.confirmpassword')"
						v-model="confirmPassword"
						type="password"
						required
						realtime
						:rules="[rules.equalsPassword]"
					></pui-text-field>
				</v-flex>
			</v-layout>
		</template>
	</pui-modal-dialog>
</template>

<script>
export default {
	name: 'PuiUserResetPasswordDialog',
	data() {
		return {
			show: false,
			titleText: this.$t('puiuserresetpassword.title'),
			messageText: '',
			usr: null,
			newPassword: null,
			confirmPassword: null,
			usePuiUserModelWebService: null,
			puiUserModel: 'puiuser',
			rules: {
				equalsPassword: (value) => value === this.newPassword || this.$t('password_not_equal')
			}
		};
	},
	props: {
		modelName: {
			type: String,
			required: true
		}
	},
	computed: {
		disableOk() {
			return !(this.newPassword !== null && this.newPassword !== '' && this.newPassword === this.confirmPassword);
		}
	},
	mounted() {
		this.subscribeToModalDialogEvent();
	},
	methods: {
		subscribeToModalDialogEvent() {
			const self = this;
			this.$puiEvents.$on('pui-modalDialog-resetPasswordUser-ok', () => {
				const url = this.$store.getters.getModelByName(this.usePuiUserModelWebService ? this.puiUserModel : this.modelName).url.setPassword;
				const params = {
					usr: this.usr,
					newPassword: this.newPassword
				};
				this.$puiRequests.getRequest(
					url,
					params,
					() => {
						self.show = false;
						this.$puiEvents.$emit(`onPui-action-running-ended-${self.modelName}`);
					},
					(error) => {
						if (error.response && error.response.data) {
							let message = error.response.data.message;
							if (error.response.data.internalCode === 202) {
								message = this.$t('puiuserresetpassword.202');
								if (message == null || message === '') {
									message = error.response.data.message;
								}
							}
							this.$puiNotify.error(message);
						}
					}
				);
			});
			this.$puiEvents.$on('pui-modalDialog-resetPasswordUser-cancel', () => {
				self.show = false;
				this.$puiEvents.$emit(`onPui-action-running-ended-${self.modelName}`);
			});
			this.$puiEvents.$on('pui-modalDialog-resetPasswordUser-show', (params) => {
				this.newPassword = null;
				this.show = true;
				// if it's an array, first parameter is the user, and second one is the model that has the WebService
				// if not, the only parameter is the user
				if (Array.isArray(params)) {
					this.usr = params[0];
					this.usePuiUserModelWebService = params[1];
				} else {
					this.usr = params;
				}
			});
		}
	},
	destroyed() {
		this.$puiEvents.$off('pui-modalDialog-resetPassword-ok');
		this.$puiEvents.$off('pui-modalDialog-resetPassword-cancel');
		this.$puiEvents.$off('pui-modalDialog-resetPassword-show');
	}
};
</script>
